import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useMutation } from "@apollo/client";

import { AuthContext } from "../../Context/AuthContext";
import { SelectUser } from "../Include/DynamicSelect";
import ListReqTakeOut from "./ListReqTakeOut";
import { CREATE_REQ_TAKE_OUT } from "../../Schema/TakeOut";
export default function CreateReqTakeOut({
  open,
  handleClose,
  setRefetch,
  dialogTitle,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectOffice, setSelectedOffice] = useState({ id: "", title: "" });
  const [selectUser, setSelecteUser] = useState({
    _id: "",
    title: "",
    profileImage: "",
  });

  const [requireField, setRequireField] = useState(false);
  const listReqTakeOutMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    key: Date.now() + Math.random(),
  };
  const [listTakeOutData, setListTakeOutData] = useState([
    listReqTakeOutMaterial,
  ]);
  // console.log("listTakeOutData", listTakeOutData);
  const handleAddReqTakeOut = () => {
    setListTakeOutData([...listTakeOutData, listReqTakeOutMaterial]);
  };
  const handleUpdateReqTakeOut = (key, val, fieldName) => {
    const newListTakeOutData = listTakeOutData?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = val;
        if (key === d.key && fieldName === "qty") d.qty = val;
      }
      return d;
    });
    setListTakeOutData(newListTakeOutData);
  };
  const handleDeleteListReqTakeOut = (key) => {
    const handleDeleteList = listTakeOutData?.filter((d) => d.key !== key);
    setListTakeOutData([...handleDeleteList]);
  };

  //createReqTakeOut
  const [createReqTakeOut] = useMutation(CREATE_REQ_TAKE_OUT, {
    onCompleted: ({ createReqTakeOut }) => {
      setLoading(false);
      if (createReqTakeOut?.status) {
        setAlert(true, "success", createReqTakeOut?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", createReqTakeOut?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });
  //formik
  const CheckValidation = Yup.object().shape({
    userId: Yup.string().required("require!"),
    remark: Yup.string(),
  });
  const formik = useFormik({
    initialValues: {
      userId: "",
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        listTakeOutData?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty > 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequireField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listReqTakeOutMaterialToSubmit = listTakeOutData?.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
          };
        });
        setLoading(true);
        createReqTakeOut({
          variables: {
            input: {
              userId: values?.userId,
              reqTakeOutMaterial: listReqTakeOutMaterialToSubmit,
              remark: values?.remark,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    resetForm();
    setSelectedOffice({ _id: "", title: "", profileImage: "" });
    setListTakeOutData([listReqTakeOutMaterial]);
  }, [open]);
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              បង្កើតសំណើរផ្ទេរចេញ
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">
                  អ្នកតំណាងការិយាល័យ
                </Typography>
                <SelectUser
                  selectedVal={selectUser}
                  setSelectedVal={setSelecteUser}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item xs={12}>
                <ListReqTakeOut
                  handleDeleteList={handleDeleteListReqTakeOut}
                  handleUpdateList={handleUpdateReqTakeOut}
                  handleAddList={handleAddReqTakeOut}
                  userId={selectOffice?.id}
                  requiredField={requireField}
                  listTakeOutData={listTakeOutData}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
